import { Component, Vue } from "vue-property-decorator";

@Component

export default class PacketRain extends Vue {
    liParams: any = [] // 红包list
    timer: any = null
    duration: number = 15000 // 总的倒计时
    succCount: number = 0 // 选中成功红包的个数
    isPre: boolean = true // 倒计时阶段
    isStart: boolean = false // 红包雨阶段
    isSucc: boolean = false // 获得红包
    isFail: boolean = false // 没有获得红包
    isCard: boolean = false // 获得招财卡
    canShow:boolean = false
    preTime: number = 3 // 倒计时时间
    activeIndex:any = null//激活的红包索引
    mounted() {
        this.preCutdown()
    }

    // 倒计时
    preCutdown() {
        let preTimer = setTimeout(() => {
            this.preTime--

            if (this.preTime === 0) {
                clearTimeout(preTimer)
                this.isPre = false
                this.isStart = true
                this.play()
            } else {
                this.preCutdown()
            }
        }, 1000)
    }

    // 开始红包雨
    play() {
        this.startRedPacket();

        let countDown = <any>this.$refs.countDown
        countDown&&countDown.start();
    }

    // 开启动画
    startRedPacket() {
        let packet: any = this.$refs.packet
        let win = packet && packet.offsetWidth
        let picWid = win / 5
        let left = Math.floor(Math.random() * (win - picWid));
        let rotate = Math.floor(Math.random() * 90 - 45) + "deg"; // 旋转角度
        // let scales = (Math.random() * (12 - 8 + 1) + 8) * 0.1; // 图片尺寸进行比例缩放
        let scales = 1; // 图片尺寸不进行缩放
        let durTime = 3.8 + "s"; // 时间
        let cls = "move_1"
        let classState = 0
        let class1:any=Math.ceil(Math.random()*11);//11不带炸弹样式，12带炸弹样式
        cls = `move_${class1}`;//通过1-12的随机数来生成随机的红包样式
        // console.log('=====',class1)
        // 不同样式的红包
        // if (left % 3 === 1) {
        //     cls = "move_2"
        // }
        // if(left % 3 === 2){
        //     cls = "move_3"
        // }
        
        this.liParams.push({
            left: left + "px",
            cls: cls,
            transforms: "rotate(" + rotate + ") scale(" + scales + ")",
            durTime: durTime,
            classState: classState
        });

        setTimeout(() => {
            // 多少时间结束
            clearTimeout(this.timer)

            return false
        }, this.duration)

        this.timer = setTimeout(() => {
            this.startRedPacket()
        }, 500);
    }

    // 回收dom节点
    removeDom(e: any) {
        let target = e.currentTarget;
        (<any>this.$refs.packet).removeChild(target);
    }

    // 倒计时结束
    finish() {
        this.$emit('packetEnd', this.succCount);
        this.resetData();//每次结束重置红包雨数据
    }

    // 选择
    // chioce(index: number) {
    //     if (this.liParams[index].classState > 0) {
    //         return false
    //     }
    //     //每次点击都在1和2之间选择一个随机数，只有数值是1的时候才算点中红包，控制点中红包的概率为理论上的50%
    //     let state: number = Math.floor(Math.random() * 2 + 1)

    //     if (state === 1) {
    //         this.succCount += 1;
    //         // this.canShow = true;
    //         console.log('this.succCount====',this.succCount)
    //     }
    //     this.liParams[index].classState = state
        
    // }
    // 选择
    chioce(index: number) {
        this.succCount += 1;
        this.activeIndex = index;
        this.liParams[index].hide = true
        // console.log('=======数据',this.succCount,index,this.liParams)
    }

    // 手动关闭
    close() {
        this.$emit("close")
    }
    //重置数据
    resetData(){
        this.succCount = 0;
        this.activeIndex = null;
        this.liParams=[];
    }
}